import { Route, Routes } from "react-router-dom";
import { RouteAuth } from "@/_old/components/auth/route";
import { lazy } from "react";

const ReasonsOfUsePage = lazy(() => import("@/reasons-of-use/view"));

const ReasonsOfUseRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RouteAuth permissions={[]}>
            <ReasonsOfUsePage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};

export { ReasonsOfUseRoutes };
